import { ItalicIcon } from "components/common/Icons/ItalicIcon";
import { useItalic } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Italic/useItalic";
import { TextBox } from "store/features/memeGenerator/types";

interface ItalicProps {
    textBox: TextBox;
}

export const Italic = ({ textBox }: ItalicProps) => {
    const { isActive, handleClick } = useItalic(textBox);
    return (
        <div
            className={`w-20 h-10 grid place-items-center ${
                isActive ? "bg-irGray-200 dark:bg-darkSurface-100" : "bg-transparent hover:bg-irGray-100"
            } rounded-lg border border-[#dfe0e2] dark:border-darkSurface-400`}
            onClick={handleClick}
        >
            <ItalicIcon />
        </div>
    );
};
